import { aboutData } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 text-center mb-10">
            <i className="ri-information-line text-primary-500 mr-2"></i>
            {aboutData.title}
          </h2>
          <div className="bg-background-100 rounded-lg p-6 md:p-8 space-y-4">
            {aboutData.paragraphs.map((p, idx) => (
              <p key={idx} className="text-sm md:text-base text-foreground-700 leading-relaxed">
                {p}
              </p>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}